import { render, staticRenderFns } from "./Rounded.vue?vue&type=template&id=4826fec4&scoped=true&"
import script from "./Rounded.vue?vue&type=script&lang=js&"
export * from "./Rounded.vue?vue&type=script&lang=js&"
import style0 from "./Rounded.vue?vue&type=style&index=0&id=4826fec4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826fec4",
  null
  
)

export default component.exports